// Percorso file: src/pages/home/HomeCoach.jsx
//
// Home del ruolo COACH — ricostruita (cantiere HOME-COACH).
//
// Sostituisce le due vecchie home gemelle HomeManager e HomeTD (diario,
// MAPPA DELLE HOME: «fusione di HomeManager + HomeTD»), demolite in
// `2462842`. La pagina è UNA SOLA per tutti i coach: chi allena una
// squadra sola passa dallo stesso elenco di chi ne allena dieci — un
// elenco di una riga — perché due varianti di pagina significano due
// pagine da tenere allineate per sempre.
//
// ⚠️ LA SORGENTE DELLE SQUADRE È LA COPPIA `teams` / `allTeams`, non più
// `approvedTeams` (modello A), che il commento del vecchio segnaposto
// dichiarava e che oggi sarebbe falso.
//
// ⚠️ RETTIFICA DI UN COMMENTO FALSO (cantiere «lettore unico», fetta F4).
// Qui stava scritto che la regola B — quella che ricava la coppia dai
// vecchi campi — «QUI NON SI RIAPPLICA», perché il coach legge sé stesso
// da `GET /users?uid=` (AuthContext.js) e «quella proiezione è già
// passata da `squadreDellaTessera` (server.js), quindi la coppia arriva
// formata anche per le tessere non ancora migrate».
// ERA FALSO, e si corregge invece di tramandarlo: il ramo `uid`
// restituisce i `contexts` COSÌ COME STANNO SUL DOCUMENTO
// (`server.js`, letto) — nessuna proiezione, nessun
// `normalizeContexts`. A proiettare è il solo `GET /users` SENZA `uid`
// (`proiezioneDiLista`, `server.js`), che è la rotta di User
// List e di Team Assignment, non di questa pagina.
// Conseguenza del presupposto falso: una tessera COACH non ancora
// riscritta — squadre nel solo `approvedTeams` — arrivava qui senza
// `teams`, e la lettura cruda le faceva sparire tutte insieme.
// Oggi la regola B si applica, e NON perché sia stata riscritta qui: la
// porta `squadreDellaTessera` dentro il lettore unico
// (`utils/squadre.js`), che questa pagina IMPORTA. Nessuna copia locale,
// nessuna terza sede della stessa regola.
//
// ⚠️ LE VECCHIE FUNZIONI `getTeamTDContext` / `isTeamTD` NON ESISTONO
// PIÙ (rimosse in `c45bb1d`), e la spia `team === "TEAMTD"` è oggi solo
// un DERIVATO che il backend ricalcola: non è una sorgente e non si
// legge. Chi è un coach lo dice il ruolo CANONICO — `canonicalRole`, la
// lente del gate unico, che fa di Manager/TD/ManagerTD un COACH — e non
// quella spia, che di una tessera senza squadre non sa nemmeno accorgersi.
//
// ⚠️ `activeContext` NON SI LEGGE E NON SI SCRIVE, ed è una scelta, non
// una dimenticanza:
//   - non si LEGGE perché è *la prima* tessera ammessa
//     (AuthContext.js, `contextsAmmessi[0]`), e un coach con due
//     tessere COACH attive ne vedrebbe una squadra sola: è proprio il
//     difetto che questa pagina deve chiudere. L'elenco si compone da
//     `user.contexts`, che le contiene tutte.
//   - non si SCRIVE perché il vecchio HomeTD faceva
//     `setActiveContext({…, team: teamName})` solo per passare la
//     squadra scelta alle pagine di destinazione; qui la squadra scelta
//     viaggia come PARAMETRO DI ROTTA (`perSquadra`: Calendar — Events,
//     Attendance e Games la prendono tutte e tre in coda all'indirizzo),
//     e cambiare il cappello globale per uno stato che
//     vive dentro una pagina cambierebbe in silenzio ciò che vedono le
//     ALTRE pagine.
// Effetto collaterale voluto: un coach con `activeContext === null` —
// tessera PENDING, o non ancora attivata — non manda in crisi la pagina,
// perché la pagina quel valore non lo guarda mai.
//
// LE VOCI DELLA PAGINA stanno su DUE livelli diversi, e la differenza è
// di sostanza:
//   - **Live Chat** è del COACH, non della squadra: il coach ha UNA chat
//     sola, che raccoglie tutte le sue squadre — come in produzione —
//     quindi la voce vive nella vista dell'ELENCO, sopra il box
//     «My teams», e dentro la singola squadra non compare;
//   - **Calendar — Events, Attendance e Games** sono della SQUADRA, e
//     compaiono solo dopo che se n'è scelta una.
// Le voci di squadra sono oggi TUTTE ACCESE (Calendar: fetta E;
// Attendance: fetta F2; Games, già «Game Call Ups»: cantiere GAMES, G1):
// nessuna « — coming soon » a schermo. Il ramo spento — `<button
// disabled>`, attenuato e non premibile (§5 «Disabilitato: opacità 50%»),
// nessuna destinazione, nessun `onClick` — resta nel reso per la voce
// che, un giorno, fosse elencata senza `to` (invariante qui sotto).
//
// ⚠️ «LIVE CHAT» È TORNATA ACCESA (cantiere LIVE CHAT): naviga a
// /messaging, la rotta della pagina Messaging, ora ricostruita e dietro
// <PrivateRoute> (App.jsx). Prende la forma delle altre voci vive —
// `<button>` con `onClick` e `navigate` — e perde la coda « — coming
// soon ».
//   ⚠️ SEQUENZA DEL TRAVASO IN PRODUZIONE: questa accensione è per il
//   COLLAUDO IN BETA (dati finti). In produzione il bottone va acceso
//   INSIEME al deploy delle regole di sicurezza della chat (il recinto),
//   MAI PRIMA: un socio non deve poter entrare in una chat il cui recinto
//   non è ancora attivo.
//
// ⚠️ «CALENDAR — EVENTS» NON È PIÙ FRA LORO (cantiere CALENDAR, fetta E):
// è la prima voce della squadra e oggi NAVIGA, a
// /my-calendar/team/<squadra>: il calendario del socio (App.jsx, dietro
// <PrivateRoute>), non il /calendar di club che resta di admin e
// superadmin. La fetta B ha tolto al coach i comandi di scrittura del
// calendario.
// ⚠️ LA SQUADRA SCELTA VIAGGIA con la voce, nell'indirizzo (`perSquadra`,
// v. VOCI_SQUADRA): questa pagina `activeContext` non lo scrive (vedi
// l'avvertenza qui sopra), e il parametro di rotta è la sola strada che
// porta la squadra fuori di qui. Chi entra da «Under 12» e chi entra da
// «Under 14» aprono quindi la settimana di QUELLA squadra.
//
// L'UNICA chiamata al backend della pagina è `GET /teams`, e da ora PARTE
// SEMPRE. La rotta è aperta a ogni utente autenticato
// (`apiRouter.get('/teams', requireAuth, …)` in `backend/server.js`:
// `requireAuth` e nient'altro — citata per contenuto e non per numero di
// riga, che slitta a ogni fetta), e la risposta serve a due cose diverse:
//   - per il coach «tutte le squadre» (`allTeams`) è l'ELENCO stesso, cioè
//     il contenuto della vista A;
//   - per OGNI coach è la mappa nome → link Australia Goal, che riempie il
//     bottone della vista B.
// ⚠️ RETTIFICA DI UN COMMENTO DIVENTATO FALSO (cantiere TEAM-LINK). Qui
// stava scritto che la chiamata «parte in UN SOLO caso: il coach “tutte le
// squadre”», e fino al 4/9/2026 era vero: la guardia `if (!tutte) return
// undefined;` la fermava per tutti gli altri. È caduta con questo cantiere,
// perché il coach normale non aveva in pagina nessun documento squadra e
// quindi nessun link da mostrare. Si corregge invece di tramandarlo, come
// per la rettifica qui sopra.
//
// Il controllo d'accesso NON sta qui: sta in App.jsx, nel cancello
// condiviso RequireRole. Questa è una home di primo livello, quindi
// nessun «Back» nella banda (doc 07 §7.2): `backTo` non si passa, e il
// ritorno all'elenco è un pulsante DENTRO la schermata.

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaChevronLeft,
  FaChevronUp,
  FaChevronDown,
  FaComments,
  FaCalendarAlt,
  FaClipboardCheck,
  FaFutbol,
  FaShoppingBag,
  FaUserCircle,
  FaLifeRing
} from "react-icons/fa";
import HomeShell from "../../components/HomeShell";
import { SOCIAL, SHOP_URL } from "../../components/clubLinks";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../api/api";
// LA SEDE UNICA DELLA LETTURA DI SQUADRA (cantiere «lettore unico», fetta
// F4): qui arriva, già scritta, l'unione che questa pagina teneva in copia
// locale. `canonicalRole` e `normalizza` non si importano più: li applica
// il modulo — il primo nel filtro di ruolo, il secondo come metro di
// grafia sui nomi e sullo status.
import { squadreDelSoggetto } from "../../utils/squadre";
import EnrolNextSeason from "./EnrolNextSeason";
// IL BOTTONE AUSTRALIA GOAL DELLA SQUADRA (cantiere TEAM-LINK): lo stesso
// componente che montano HomePlayer e HomeChild, con la sua guardia dentro.
import AustraliaGoalButton from "./AustraliaGoalButton";
// DOPO il telaio, e l'ordine conta: HomeShell porta con sé HomeShell.css,
// e questo foglio ne ritocca le regole (la riga della squadra e il doppio
// respiro). Se salisse sopra, il telaio lo sovrascriverebbe.
import "./HomeCoach.css";

// LE TRE VOCI DELLA SQUADRA, nell'ordine deciso dall'incarico.
// Il separatore delle voci composte è il trattino lungo con spazi (§3.3).
//
// ⚠️ LA LIVE CHAT NON È QUI, ed è una decisione del committente, non una
// dimenticanza: il coach ha UNA chat sola, che raccoglie tutte le sue
// squadre — è come funziona in produzione — e non una chat per squadra.
// Perciò è una voce del COACH e vive nella vista dell'elenco, sopra il
// box «My teams»; dentro la singola squadra non compare.
//
// ⚠️ ATTENDANCE È ACCESA (cantiere ATTENDANCE, fetta F2), ed è una voce
// PER SQUADRA come il calendario: porta a `/attendance/team/<squadra>`,
// cioè il riepilogo di QUELLA squadra e di nessun'altra. Non ha un
// `disabled` scritto a mano — non ne ha mai avuti: l'interruttore è `to`
// (invariante qui sotto), e accendere una voce vuol dire darle un
// indirizzo. Così si è accesa anche Games (già «Game Call Ups», cantiere
// GAMES, fetta G1): oggi nessuna voce di squadra è spenta.
//
// ⚠️ Qui NON c'è un flag `wip`: a distinguere una voce viva da una spenta
// basta `to`. Le voci spente non portano `to`: non c'è dove andare, e un
// indirizzo scritto qui sarebbe una promessa che il pulsante non mantiene.
// Chi ha `to` naviga, chi non ce l'ha resta `<button disabled>` con
// « — coming soon » in coda all'etichetta. La chiave della lista resta
// l'etichetta, non `to`, perché `to` potrebbe mancare.
//
// `spaced: true` è il DOPPIO RESPIRO (HomeCoach.css): sta sulla voce che
// APRE il gruppo che si stacca, mai in coda a quella che lo precede. Lo
// porta la PRIMA voce dell'elenco — oggi Calendar — Events, che ha
// ereditato il flag dalla Live Chat quando questa è salita al livello del
// coach — e serve a isolare in cima il «Back to teams» che la precede.
// Se un giorno l'ordine cambiasse, il flag va spostato con la testa
// dell'elenco: è quello il suo posto, non una voce in particolare.
//
// Le icone sono Font Awesome, mai emoji (§5, regola tutto-o-niente), e
// sono le STESSE che le altre home danno alle stesse voci: FaCalendarAlt
// come in HomeAdmin, FaClipboardCheck come «My Attendance» in HomePlayer,
// FaFutbol come la vecchia «Game Call Ups» di HomePlayer (voce tolta in
// R8.2).
// `perSquadra: true` dice una cosa sola: la destinazione vuole in coda la
// SQUADRA APERTA, come parametro di rotta. Sta sulla voce e non nel punto
// che naviga perché è una proprietà della destinazione, non del gesto — e
// perché scrivere l'indirizzo due volte (qui e nel confronto) sarebbe la
// prima copia di una serie. Il blocco che rende queste voci esiste solo
// dentro `{squadraScelta && ...}`, quindi dove si compone l'indirizzo la
// squadra c'è sempre.
const VOCI_SQUADRA = [
  { label: "Calendar — Events", to: "/my-calendar", perSquadra: true, Icon: FaCalendarAlt, spaced: true },
  { label: "Attendance", to: "/attendance", perSquadra: true, Icon: FaClipboardCheck },
  // GAMES (cantiere GAMES, fetta G1): la voce che era «Game Call Ups» e
  // stava spenta, RIACCESA e RINOMINATA — decisione del committente, PIANO
  // §1. Si accende come le altre due: un `to` e `perSquadra`, quindi porta
  // a `/games/team/<squadra>`, la lista partite di QUELLA squadra. La
  // vecchia pagina /gamecallups non c'entra: lato frontend è stata tolta
  // (98b5be7).
  { label: "Games", to: "/games", perSquadra: true, Icon: FaFutbol }
];

/* ===============================
   L'ORDINE PERSONALE DELL'ELENCO «My teams» (cantiere HOMECOACH-RIORDINO)

   Il coach può riordinare le proprie squadre con le due frecce che ogni
   riga della vista A porta a fianco; l'ordine vive in `localStorage`,
   TUTTO FRONTEND: nessuna rotta, nessun campo di persona, `GET /teams`
   resta com'è.

   ⚠️ LA FORMA È QUELLA DI `qpscHelpLanguage` (enrolAiuto.jsx) e di
   `CHIAVE_EMAIL_ACCESSO` (Login.jsx), non una nuova: costante esportata,
   `window.localStorage`, ogni accesso in `try/catch` con degrado
   silenzioso, valore riletto e VALIDATO prima dell'uso. La chiave è
   globale per browser, come le altre di casa: non è legata all'identità
   di chi è entrato, e sopravvive al logout (che rimuove la sola
   `userBackend`, AuthContext.js) e a un nuovo accesso sullo stesso
   browser. L'unica differenza rispetto alla lingua d'aiuto è che qui il
   valore è una LISTA, quindi passa da JSON — la forma che
   `attAlertDismissed` (Attendance.jsx) ha già per un array in storage.

   ⚠️ QUI DENTRO NON FINISCE NESSUN DATO PERSONALE: solo NOMI DI SQUADRA,
   che sono già a schermo e sul documento squadra. Nessun uid, nessuna
   email, nessun nome di persona.

   LA CHIAVE D'ORDINE È IL NOME, ed è l'unico dato stabile che la pagina
   ha: `elenco` è un array di STRINGHE in entrambi i rami (v. l'avvertenza
   su `linkPerSquadra`), e sul documento squadra `id === name`. È lo
   stesso metro — il nome ESATTO — con cui il bottone Australia Goal si
   aggancia alla sua squadra. Limite noto e accettato: una squadra
   RINOMINATA è, per questa memoria, una squadra nuova — finisce in coda,
   e basta risistemarla.

   LA REGOLA DI FUSIONE (`applicaOrdine`): prima le squadre PRESENTI che
   compaiono nell'ordine salvato, nell'ordine salvato; poi le presenti non
   salvate, in coda, nell'ordine di default (le tessere per il coach
   normale, `GET /teams` per il coach «tutte le squadre»); le voci salvate
   che non esistono più si ignorano, e cadono da sole al gesto
   successivo, perché si salva sempre l'elenco reale INTERO nel nuovo
   ordine e mai il solo scambio. A schermo c'è SEMPRE l'insieme vero
   delle squadre del coach, mai una lista congelata.
=============================== */
export const CHIAVE_ORDINE_SQUADRE = "qpscCoachTeamsOrder";

/** `null` = nessun ordine personale, cioè l'ordine di default. */
function ordineSalvato() {
  try {
    const letto = JSON.parse(window.localStorage.getItem(CHIAVE_ORDINE_SQUADRE));
    if (!Array.isArray(letto)) return null;

    // Solo stringhe non vuote, senza doppioni: tutto il resto — chiave
    // manomessa, o scritta da una versione futura — vale come «nulla».
    const nomi = letto.filter(
      (voce, i) =>
        typeof voce === "string" && voce.trim() !== "" && letto.indexOf(voce) === i
    );
    return nomi.length > 0 ? nomi : null;
  } catch (_) {
    return null;
  }
}

function salvaOrdine(nomi) {
  try {
    if (Array.isArray(nomi) && nomi.length > 0) {
      window.localStorage.setItem(CHIAVE_ORDINE_SQUADRE, JSON.stringify(nomi));
    } else {
      window.localStorage.removeItem(CHIAVE_ORDINE_SQUADRE);
    }
  } catch (_) {
    /* localStorage non disponibile: si prosegue lo stesso. */
  }
}

function applicaOrdine(elenco, ordine) {
  if (!Array.isArray(ordine) || ordine.length === 0) return elenco;

  const presenti = new Set(elenco);
  const inTesta = ordine.filter((nome) => presenti.has(nome));
  const giaMessi = new Set(inTesta);

  return inTesta.concat(elenco.filter((nome) => !giaMessi.has(nome)));
}

/* ===============================
   LE SQUADRE CHE QUESTA PERSONA ALLENA — la copia di pagina NON C'È PIÙ

   Qui viveva `squadreDelCoach`: copia dichiarata di `squadreDellaPersona`
   di UsersList.jsx, con UNA differenza voluta — le sole tessere il cui
   ruolo canonico è COACH (differenza D6 del cantiere: chi allena l'U10 e
   gioca nell'U18 non deve trovarsi l'U18 fra le squadre che ALLENA). Il
   corpo è ora quello del lettore unico, invariato: non è stata riscritta
   una riga, è stata tolta una copia.

   `squadreDelSoggetto(user?.contexts, null, { ruoli: ["COACH"], doppioni: "normalizzati" })` dice
   la stessa cosa, con i parametri al posto delle differenze:

     `contexts`          i `contexts`, non il documento intero. Si sommano
                         TUTTE le tessere, perché le squadre di un coach
                         arrivano da due strade e tutte e due esistono nei
                         dati: UNA tessera COACH con più nomi in `teams`
                         (`saveApprovedTeams` di TeamAssignment), oppure
                         PIÙ tessere COACH attive, una per squadra (la
                         porta di scrittura è per TESSERA).
     `anno = null`       il calendario e la home del coach non conoscono le
                         stagioni (differenza D8): `user.contexts` arriva
                         GIÀ filtrato all'anno operativo da AuthContext
                         (`tessereDellAnnoOperativo` →
                         `contexts: contextsAmmessi`).
                         `null` significa «annata ignota → la regola
                         dell'anno non si applica»: filtrare di nuovo qui
                         sarebbe un secondo cancello sullo stesso dato.
     `ruoli: ["COACH"]`  la differenza D6, detta col parametro.
     `doppioni:          passato ESPLICITAMENTE (non è un default), per
      "normalizzati"`    riprodurre il confronto normalizzato della copia
                         tolta: appaia «U12» con «u12», conserva la grafia
                         della prima occorrenza, scarta i vuoti.
     (default)           solo tessere ACTIVE e nessuna tessera amministrativa,
                         come la copia tolta. `allTeams` ASSORBE i nomi (li
                         svuota per una tessera «tutte le squadre»): questo
                         DIFFERISCE dalla copia tolta, che i nomi delle altre
                         tessere li teneva — ma qui è senza effetto, perché con
                         «tutte le squadre» l'elenco è `squadreDelClub`, non
                         `nomi`.

   ⚠️ CAMBIA UN ESITO, ed è la riparazione decisa dal committente (fetta
   F4, Q5.1): la copia leggeva `ctx.teams` / `ctx.allTeams` CRUDI, e la
   sorgente di questa pagina è grezza (v. la rettifica in testa al file).
   Il modulo porta il ripiego della «regola B», quindi una tessera COACH
   di forma vecchia — squadre nel solo `approvedTeams` — da qui in avanti
   mostra le sue squadre invece di nessuna. Chi ha la tessera nuova non
   vede alcuna differenza.
=============================== */

const HomeCoach = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // LO STATO DEI DUE LIVELLI, e non ce n'è un secondo: `null` è l'elenco,
  // un nome è la schermata di quella squadra. È lo stesso `selectedTeam`
  // del vecchio HomeTD, meno il cappello che quello scriveva insieme
  // (vedi l'avvertenza su `activeContext` in testa al file).
  const [squadraScelta, setSquadraScelta] = useState(null);

  const { nomi, tutte } = useMemo(
    () => squadreDelSoggetto(user?.contexts, null, { ruoli: ["COACH"], doppioni: "normalizzati" }),
    [user]
  );

  // L'ELENCO DEL CLUB, e solo per il coach «tutte le squadre».
  // `null` significa «non ancora arrivato», che non è la stessa cosa di
  // un elenco vuoto: il vuoto è una risposta, il null è un'attesa.
  const [squadreDelClub, setSquadreDelClub] = useState(null);
  const [letturaFallita, setLetturaFallita] = useState(false);

  // LA MAPPA NOME → LINK «AUSTRALIA GOAL», costruita sulla STESSA risposta
  // di `GET /teams` (cantiere TEAM-LINK).
  //
  // ⚠️ È UNA MAPPA A LATO, e non un cambio di tipo di `squadreDelClub`, ed
  // è una scelta di disegno presa apposta: `elenco` è un array di STRINGHE
  // in entrambi i suoi rami — quello del club e quello delle tessere — e i
  // cinque rami di `bloccoElenco`, il `.map` e la sua `key` ci lavorano
  // sopra. Trasformarlo in un array di oggetti avrebbe toccato tutto
  // quello per esporre un campo che serve a UN bottone, in un'altra vista.
  // L'elenco «My teams» resta identico: qui si AGGIUNGE un dato, non si
  // cambia il dato che c'era.
  //
  // La forma è quella di `categoriaDi` in HomeParent.jsx — `new Map` dai
  // documenti, chiave il NOME — e la ragione della chiave è la stessa: la
  // tessera porta il nome della squadra, non il suo id (e sul documento
  // squadra `id === name`). Vuota finché la risposta non arriva: una mappa
  // vuota non dà link, e senza link il bottone non si mostra.
  const [linkPerSquadra, setLinkPerSquadra] = useState(() => new Map());

  // ⚠️ LA LETTURA ORA PARTE SEMPRE (cantiere TEAM-LINK), e prima partiva
  // solo per il coach «tutte le squadre» (`if (!tutte) return undefined;`).
  // È l'unica chiamata di rete NUOVA del cantiere, ed è stata decisa, non
  // subita: senza di essa il coach normale — quello con le squadre scritte
  // in tessera, cioè il caso ordinario — non avrebbe in pagina NESSUN
  // documento squadra, quindi nessun link da mostrare. La rotta è la stessa
  // di prima, aperta a ogni utente autenticato (`requireAuth` e nient'altro
  // in `backend/server.js`): nessun permesso da toccare, nessuna collezione
  // nuova.
  // Il coach «tutte le squadre» la faceva già: per lui non cambia nulla.
  //
  // La dipendenza resta il BOOLEANO `tutte`, non l'oggetto `user`, e ora
  // `tutte` serve nella `.catch` invece che come guardia d'ingresso (vedi
  // sotto): `refreshUserFromBackend`
  // restituisce un oggetto NUOVO a ogni chiamata (avvertenza di
  // HomeIncomplete.jsx, ripresa da HomeParent e HomePlayer), e
  // un effetto che dipendesse da `user` rileggerebbe le squadre a ogni
  // giro. La sentinella `annullato` evita di scrivere su un componente
  // smontato: è la stessa forma di HomePlayer.jsx.
  //
  // ⚠️ Qui il guasto NON si può tacere, e questa è la differenza con
  // HomePlayer: là a cadere era una pastiglia decorativa e il dato che
  // contava restava a schermo, qui cadrebbe il CONTENUTO della pagina.
  // Quindi si registra, e l'elenco lo dice.
  useEffect(() => {
    // ⚠️ L'AZZERAMENTO RESTA IN TESTA (rilievo R1). Non c'è più un'uscita
    // anticipata sotto di lui, ma la ragione per cui sta qui non è
    // cambiata: il flag è la memoria di UN tentativo, e si azzera a ogni
    // rientro dell'effetto — cioè a ogni cambio di `tutte` — prima che il
    // tentativo nuovo cominci. Un coach a cui la lettura era fallita e che
    // poi riceve le squadre in tessera, perdendo `allTeams` senza
    // ricaricare la pagina, non si porta dietro la nota «Teams could not
    // be loaded» sopra le squadre che invece adesso ha.
    setLetturaFallita(false);

    let annullato = false;

    api
      .get("/teams")
      .then((dati) => {
        if (annullato) return;

        // I DOCUMENTI INTERI, letti UNA volta e usati due: l'elenco vuole i
        // soli nomi, il bottone Australia Goal vuole il link. Prima questa
        // riga era dentro la `.map`, e il documento veniva ridotto a stringa
        // sul posto: il `link` arrivava dal backend e si perdeva qui, in
        // silenzio (cantiere TEAM-LINK).
        const documenti = Array.isArray(dati) ? dati : [];

        // Si prende il NOME, che è ciò che l'elenco mostra e ciò che
        // tutto il modello dati memorizza (`users.team`, `contexts[].team`,
        // `approvedTeams`: il NOME, non l'id — e sul documento squadra
        // `id === name`, invariante dichiarata da `POST /teams` in
        // `backend/server.js`, che nomina il documento col nome stesso —
        // `const teamId = String(name).trim()`; citata per contenuto e non
        // per numero di riga, che slitta a ogni fetta).
        // Le voci senza nome non sono squadre e non entrano.
        //
        // ⚠️ SI SCRIVE ANCHE PER IL COACH NORMALE, ed è senza effetto: la
        // riga che compone ciò che si vede è `elenco = tutte ?
        // squadreDelClub || [] : nomi`, quindi per lui questo stato non si
        // legge mai. Scriverlo comunque costa nulla e tiene la `.then` con
        // un ramo solo, invece di due strade che si allontanano.
        setSquadreDelClub(
          documenti
            .map((t) =>
              t && typeof t === "object" ? String(t.name || "").trim() : ""
            )
            .filter((nome) => nome !== "")
        );

        // LA MAPPA NOME → LINK, dagli stessi documenti. Stessa forma di
        // `categoriaDi` in HomeParent.jsx. Entrano solo le squadre che
        // hanno DAVVERO un link: `String(...).trim()` scarta il campo
        // assente, non testuale o di soli spazi, e una squadra senza link
        // semplicemente non è nella mappa — il bottone, che non trova
        // nulla, tace.
        setLinkPerSquadra(
          new Map(
            documenti
              .filter((t) => t && typeof t === "object")
              .map((t) => [
                String(t.name || "").trim(),
                String(t.link || "").trim()
              ])
              .filter(([nome, link]) => nome !== "" && link !== "")
          )
        );
      })
      .catch(() => {
        // ⚠️ IL GUASTO SI REGISTRA SOLO PER IL COACH «TUTTE LE SQUADRE»,
        // ed è la conseguenza da non sbagliare ora che la lettura parte per
        // tutti. `bloccoElenco` guarda `letturaFallita` PRIMA dell'elenco:
        // accenderlo per il coach normale gli sostituirebbe le squadre
        // scritte in tessera — che sono in pagina e non dipendono da questa
        // chiamata — con la nota «Teams could not be loaded». Per lui il
        // guasto costa il solo bottone Australia Goal, che infatti tace: la
        // mappa resta vuota, come alla pastiglia di HomePlayer resta muta
        // la categoria.
        if (!annullato && tutte) setLetturaFallita(true);
      });

    return () => {
      annullato = true;
    };
  }, [tutte]);

  // L'elenco che la pagina mostra: quello del club se il permesso è
  // «tutte le squadre», altrimenti i nomi scritti nelle tessere.
  const elenco = tutte ? squadreDelClub || [] : nomi;

  // Attesa vera: si aspetta solo se c'è qualcosa in arrivo.
  const inAttesa = tutte && squadreDelClub === null && !letturaFallita;

  // L'ORDINE PERSONALE (cantiere HOMECOACH-RIORDINO), letto UNA volta dal
  // browser all'apertura della pagina — inizializzatore pigro, così la
  // lettura non si ripete a ogni resa. `null` è l'ordine di default. Si
  // scrive nei due soli gesti qui sotto, e sempre insieme allo storage:
  // lo stato è ciò che si vede, lo storage è ciò che si ritrova.
  const [ordine, setOrdine] = useState(ordineSalvato);

  // Ciò che il gruppo-scelta mostra: l'elenco reale, fuso con l'ordine
  // salvato (regola in testa al file). I quattro rami di `bloccoElenco`
  // che precedono il gruppo guardano `elenco.length`, che la fusione non
  // cambia: stesso insieme, altro ordine.
  const elencoOrdinato = applicaOrdine(elenco, ordine);

  // LO SCAMBIO CON LA VICINA: `verso` è -1 (su) o +1 (giù). La guardia
  // sui bordi è ridondante con il `disabled` delle frecce, e resta:
  // un gesto fuori dall'elenco non deve poter scrivere nulla.
  const spostaSquadra = (indice, verso) => {
    const altro = indice + verso;
    if (altro < 0 || altro >= elencoOrdinato.length) return;

    const nuovo = elencoOrdinato.slice();
    [nuovo[indice], nuovo[altro]] = [nuovo[altro], nuovo[indice]];
    setOrdine(nuovo);
    salvaOrdine(nuovo);
  };

  // IL RITORNO AL DEFAULT: cancella la chiave e torna all'`elenco` così
  // com'è. Nessun'altra memoria da azzerare.
  const azzeraOrdine = () => {
    setOrdine(null);
    salvaOrdine(null);
  };

  // LA MODALITÀ RIORDINO (cantiere HOMECOACH-RIORDINO-2): stato di SOLA
  // INTERFACCIA, mai persistito. Fuori modalità il riquadro è pulito —
  // solo squadre, nessuna freccia — e in coda c'è «Change order»; dentro,
  // compaiono le frecce e la coda mostra «Confirm order». Si esce SOLO
  // con «Confirm order»: nessun timer, nessuna sparizione automatica. Al
  // ricaricamento si riparte fuori modalità, mentre l'ordine salvato
  // (`ordine`, qui sopra) resta e si applica come sempre. «Confirm order»
  // non salva nulla: ogni freccia ha già scritto nello storage.
  const [modificaOrdine, setModificaOrdine] = useState(false);

  // IL BLOCCO DELL'ELENCO, con i suoi casi limite. È una funzione e non
  // una catena di ternari dentro il JSX perché i rami sono cinque, e
  // cinque ternari annidati si leggono male e si sbagliano peggio.
  //
  // ⚠️ Nessun ramo distingue «tessera PENDING» da «tessera ACTIVE senza
  // squadre»: sono due strade allo stesso stato, e sceglierne una sarebbe
  // una diagnosi che i dati non autorizzano. Il messaggio dice il fatto —
  // nessuna squadra — e indirizza al club.
  const bloccoElenco = () => {
    if (inAttesa) {
      return <p className="qpsc-note">Loading teams&hellip;</p>;
    }

    if (letturaFallita) {
      return (
        <p className="qpsc-note">
          Teams could not be loaded. Please try again later.
        </p>
      );
    }

    // ⚠️ IL VUOTO HA DUE SIGNIFICATI, e vanno detti con due frasi diverse
    // (rilievo R2). Con `tutte` vero l'elenco è quello del CLUB: se è
    // vuoto, il club non ha ancora squadre — e dire a un coach che può
    // vederle tutte «nessuna squadra ti è stata assegnata, contatta il
    // club» sarebbe falso due volte, perché un'assegnazione non gli serve
    // e il club sarebbe lui a doverlo chiamare. Nessuna lettura in più
    // per distinguerli: il booleano è già qui.
    if (tutte && elenco.length === 0) {
      return <p className="qpsc-note">No teams have been set up yet.</p>;
    }

    if (elenco.length === 0) {
      return (
        <p className="qpsc-note">
          No teams assigned yet. Please contact the club.
        </p>
      );
    }

    // §6 GRUPPO-SCELTA: qui si sceglie fra opzioni, ed è la definizione
    // del pulsante scuro §5.2 — il pulsante oro è «azione o voce di
    // navigazione unica», che una squadra fra molte non è. Stesso markup
    // di HomeContext.jsx («Continue as»).
    //
    // ⚠️ Con UNA squadra sola il gruppo ha una riga sola, e resta un
    // gruppo: non esiste un ramo «se una, salta l'elenco». Una sola
    // situazione, una sola pagina.
    //
    // La chiave è il nome: i nomi delle tessere sono già deduplicati qui
    // sopra, e quelli del club sono unici per costruzione (`id === name`).
    //
    // OGNI SQUADRA È UNA RIGA (cantiere HOMECOACH-RIORDINO): il pulsante
    // scuro di sempre, intero e tutto cliccabile, più le due frecce che la
    // spostano di un posto. Le frecce sono <button> a sé, FUORI dal
    // pulsante-squadra (un bottone dentro un bottone non è HTML valido),
    // e la riga è il figlio del gruppo-scelta al posto del pulsante nudo:
    // il gruppo, i suoi gap e il suo bordo oro non cambiano. La freccia
    // che non può muovere — su in cima, giù in fondo — è `disabled`, con
    // la resa §5 del telaio (opacità, mai colori diversi). L'etichetta
    // accessibile porta il nome della squadra, che è già a schermo.
    //
    // LE FRECCE SOLO IN MODALITÀ (cantiere HOMECOACH-RIORDINO-2): fuori
    // da `modificaOrdine` la riga è il solo pulsante-squadra, pulito come
    // prima delle frecce. In modalità il pulsante-squadra NON naviga —
    // guardia sull'onClick, non `disabled`, che lo ingrigirebbe: si è lì
    // per ordinare, non per entrare.
    //
    // LA CODA DEL RIQUADRO, due stati, stesso vestito discreto del reset:
    //   fuori modalità → «Change order», solo con PIÙ di una squadra (con
    //                    0 o 1 non c'è nulla da ordinare);
    //   in modalità    → «Confirm order» (esce e basta: l'ordine è già
    //                    salvato a ogni freccia) e, accanto, «Reset order»
    //                    solo quando un ordine personale ESISTE (`ordine`
    //                    non nullo): senza memoria non c'è nulla da
    //                    azzerare, e un comando che non fa niente non si
    //                    mostra.
    return (
      <div className="qpsc-choice-group">
        <span className="qpsc-choice-group__label">My teams</span>
        {elencoOrdinato.map((nome, indice) => (
          <div key={nome} className="qpsc-coach-teamrow">
            <button
              type="button"
              className="qpsc-btn-dark qpsc-coach-teamrow__team"
              onClick={() => {
                if (!modificaOrdine) setSquadraScelta(nome);
              }}
            >
              {nome}
            </button>
            {modificaOrdine && (
              <button
                type="button"
                className="qpsc-coach-teamrow__arrow"
                title="Move up"
                aria-label={`Move ${nome} up`}
                disabled={indice === 0}
                onClick={() => spostaSquadra(indice, -1)}
              >
                <FaChevronUp />
              </button>
            )}
            {modificaOrdine && (
              <button
                type="button"
                className="qpsc-coach-teamrow__arrow"
                title="Move down"
                aria-label={`Move ${nome} down`}
                disabled={indice === elencoOrdinato.length - 1}
                onClick={() => spostaSquadra(indice, 1)}
              >
                <FaChevronDown />
              </button>
            )}
          </div>
        ))}
        {!modificaOrdine && elencoOrdinato.length > 1 && (
          <button
            type="button"
            className="qpsc-coach-order-reset"
            onClick={() => setModificaOrdine(true)}
          >
            Change order
          </button>
        )}
        {modificaOrdine && (
          <div className="qpsc-coach-order-actions">
            <button
              type="button"
              className="qpsc-coach-order-reset"
              onClick={() => setModificaOrdine(false)}
            >
              Confirm order
            </button>
            {ordine && (
              <button
                type="button"
                className="qpsc-coach-order-reset"
                onClick={azzeraOrdine}
              >
                Reset order
              </button>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <HomeShell>
      {/* Il titolo è lo stesso nelle due viste: è il nome della PAGINA,
          non del livello. Nella famiglia delle home ricostruite si legge
          «QPSC Player», «QPSC Parent Area», «QPSC Minor Area»: «Panel»
          del vecchio HomeTD non lo usa nessun'altra. */}
      <h1 className="qpsc-page-title">QPSC Coach</h1>

      {/* Dentro la squadra, il suo nome sotto il titolo — come la riga
          squadra di HomePlayer. NIENTE pastiglia di categoria: la
          pastiglia vorrebbe la categoria della squadra, cioè una lettura
          in più che questa pagina non fa e che l'incarico non chiede. */}
      {squadraScelta && <p className="qpsc-coach-team">{squadraScelta}</p>}

      {/* §7.3 i quattro canali del club: glifi oro nudi, su una riga
          centrata. Stesso markup di tutte le home ricostruite; gli
          indirizzi arrivano dalla sede unica, components/clubLinks.js, e
          non si ricopiano. */}
      <div className="qpsc-social">
        {SOCIAL.map(({ href, title, Icon }) => (
          <a
            key={title}
            className="qpsc-social__link"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            title={title}
            aria-label={title}
          >
            <Icon />
          </a>
        ))}
      </div>

      {/* LA LIVE CHAT È UNA VOCE DEL COACH, non della squadra (decisione
          del committente): una chat sola, che raccoglie tutte le sue
          squadre, come in produzione. Per questo sta QUI — nella vista
          dell'elenco, fra i canali del club e il box «My teams» — e non
          fra le voci di VOCI_SQUADRA: dentro una squadra non compare.
          È ACCESA (cantiere LIVE CHAT): naviga a /messaging, la rotta
          della pagina Messaging (App.jsx, dietro <PrivateRoute>), con la
          forma delle altre voci vive della pagina — `<button>` con
          `onClick` e `navigate`, mai un `<Link>` — e l'etichetta perde la
          coda « — coming soon ».
          ⚠️ SEQUENZA DEL TRAVASO IN PRODUZIONE: questa accensione è per il
          COLLAUDO IN BETA (dati finti). In produzione il bottone va acceso
          INSIEME al deploy delle regole di sicurezza della chat (il
          recinto), MAI PRIMA: un socio non deve poter entrare in una chat
          il cui recinto non è ancora attivo.
          Sta in un <nav> suo perché è una voce di menu e le voci di menu
          stanno nei <nav> (è il modo di HomeParent, che di <nav> ne ha
          due proprio perché un altro blocco si incunea fra loro). Il
          respiro attorno è quello normale del §4, 16px, che porta già il
          `gap` della colonna: nessun margine da dichiarare. */}
      {!squadraScelta && (
        <nav className="qpsc-menu">
          <button
            type="button"
            className="qpsc-btn-gold"
            onClick={() => navigate("/messaging")}
          >
            <span className="qpsc-btn-gold__icon">
              <FaComments />
            </span>
            Live Chat
          </button>
        </nav>
      )}

      {/* IL RINNOVO (YS-11.2), sotto la Live Chat. Si mostra da sé solo a
          stagioni sovrapposte e a iscrizioni aperte — la condizione sta tutta
          dentro il componente, che legge la cassettina della stagione da
          `useAuth()`: qui non c'è nulla da decidere.
          Sta nel `{!squadraScelta && ...}` come la Live Chat, ed è accettato
          (deciso dall'utente) che sparisca entrando in una squadra: questa è
          la vista ELENCO, e il rinnovo appartiene alla persona, non alla
          squadra. Un coach che sia anche genitore lo ritrova tornando
          all'elenco col «Back to teams». */}
      {!squadraScelta && <EnrolNextSeason />}

      {/* VISTA A: l'elenco delle squadre. Sparisce quando si entra in una
          squadra, e torna col «Back to teams» qui sotto. */}
      {!squadraScelta && bloccoElenco()}

      {/* L'ALTRO <nav>: le voci della squadra ci entrano quando c'è una
          squadra scelta, le tre voci PERSONALI (Shop, My Profile, «More /
          Assistance») ci sono sempre. È la disposizione del vecchio
          HomeTD, dove Shop e My Profile stavano fuori da entrambi i
          blocchi condizionali: non appartengono né all'elenco né alla
          squadra. */}
      <nav className="qpsc-menu">
        {squadraScelta && (
          <>
            {/* IL RITORNO ALL'ELENCO, e sta QUI dentro, non nella banda
                del telaio: la home coach è di primo livello e la banda
                non ha un «Back» (doc 07 §7.2). Fa una cosa sola —
                azzerare lo stato — e non naviga, non tocca
                `activeContext`, non chiama il backend. Il glifo è
                FaChevronLeft, lo STESSO del Back della banda
                (NavBand.jsx): non se ne sceglie uno nuovo per
                dire la stessa cosa. */}
            <button
              type="button"
              className="qpsc-btn-gold"
              onClick={() => setSquadraScelta(null)}
            >
              <span className="qpsc-btn-gold__icon">
                <FaChevronLeft />
              </span>
              Back to teams
            </button>

            {VOCI_SQUADRA.map(({ label, to, perSquadra, Icon, spaced }) => {
              // LA SQUADRA APERTA VIAGGIA NELL'INDIRIZZO. Finché il
              // calendario non la riceveva, mostrava l'UNIONE di tutte le
              // squadre di questo allenatore — nome e filtro insieme — e la
              // scelta fatta qui sopra si fermava a questa pagina: lo stato
              // `squadraScelta` è interno e nessuno lo scrive altrove (non
              // tocca `activeContext`, v. l'avvertenza in testa al file).
              // Il parametro di rotta è la sola strada che sopravvive al
              // ricaricamento; `encodeURIComponent` perché un nome di
              // squadra è testo libero, come per l'id del figlio in
              // HomeParent.jsx.
              const destinazione = perSquadra
                ? `${to}/team/${encodeURIComponent(squadraScelta)}`
                : to;

              return to ? (
                <button
                  key={label}
                  type="button"
                  className={"qpsc-btn-gold" + (spaced ? " qpsc-coach-spaced" : "")}
                  onClick={() => navigate(destinazione)}
                >
                  <span className="qpsc-btn-gold__icon">
                    <Icon />
                  </span>
                  {label}
                </button>
              ) : (
                <button
                  key={label}
                  type="button"
                  className={"qpsc-btn-gold" + (spaced ? " qpsc-coach-spaced" : "")}
                  disabled
                >
                  <span className="qpsc-btn-gold__icon">
                    <Icon />
                  </span>
                  {label} &mdash; coming soon
                </button>
              );
            })}
          </>
        )}

        {/* IL BOTTONE AUSTRALIA GOAL DELLA SQUADRA (cantiere TEAM-LINK),
          DENTRO questo secondo `<nav>`, come blocco in coda alle voci di
          squadra (dopo Games) e prima delle voci sempre presenti. Non è
          una voce di rotta: è il link che l'admin imposta per la squadra.
          ⚠️ SOLO NELLA VISTA B, la schermata della singola squadra: è di
          QUELLA squadra, e nella vista A — l'elenco «My teams» — non
          esisterebbe un posto dove metterlo. Là ogni squadra è un `<button>`
          intero e tutto cliccabile: un `<a>` accanto o dentro sarebbe una
          riga a due comandi che il gruppo-scelta non ha, e un `<a>` dentro
          un `<button>` non è nemmeno HTML valido.
          ⚠️ Sta IN CODA alle voci di squadra, mai in mezzo, e non è un
          dettaglio: il doppio respiro `qpsc-coach-spaced` sta sulla TESTA
          di quel gruppo (oggi Calendar) per isolare il «Back to teams», e
          infilarcisi in mezzo sposterebbe quella testa. Qui il bottone è un
          blocco in coda e non tocca il flag.
          `squadraScelta` è una STRINGA: il link si risale dalla mappa, per
          nome ESATTO, con lo stesso metro con cui le altre due home
          agganciano la squadra al suo documento. Squadra senza link →
          `undefined` → il componente non rende nulla.
          ⚠️ NESSUN MARGINE: il respiro §4 (16px) lo porta già il `gap` di
          `.qpsc-menu`; dichiararlo lo raddoppierebbe a 32. */}
      {squadraScelta && (
        <AustraliaGoalButton link={linkPerSquadra.get(squadraScelta)} />
      )}

        {/* CLINIC / OFF SEASON / SPECIALS (23/9/2026): l'ingresso all'area
            clinic del socio, /clinics, uscito da More per decisione del
            committente. Sta nel gruppo delle voci sempre presenti, quindi
            in entrambe le viste. Etichetta e icona sono quelle del bottone
            admin (HomeAdmin.jsx). Voce INTERNA: `<button>` con `navigate`,
            come My Profile — non la forma `<a>` dello Shop, che è un link
            esterno — e oro NORMALE (l'accento resta allo Shop). */}
        <button
          type="button"
          className="qpsc-btn-gold"
          onClick={() => navigate("/clinics")}
        >
          <span className="qpsc-btn-gold__icon">
            <FaFutbol />
          </span>
          Clinic / Off Season / Specials
        </button>

        {/* Unica voce esterna, e unica variante d'accento della pagina
            (§5.1: al massimo una — My Profile qui sotto resta un pulsante
            oro NORMALE). Porta il DOPPIO RESPIRO in testa: stacca il
            gruppo personale da ciò che lo precede, che è il gruppo-scelta
            delle squadre nella vista A e le tre voci di squadra nella
            vista B. L'indirizzo arriva da clubLinks. */}
        <a
          className="qpsc-btn-gold qpsc-btn-gold--accent qpsc-coach-spaced"
          href={SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="qpsc-btn-gold__icon">
            <FaShoppingBag />
          </span>
          QPSC Online Shop
        </a>

        {/* Voce INTERNA: `<button>` con `navigate`, mai un `<Link>` — è lo
            schema di tutte le home ricostruite. Destinazione e icona sono
            quelle che «My Profile» ha nelle home vecchie e in HomePlayer. */}
        <button
          type="button"
          className="qpsc-btn-gold"
          onClick={() => navigate("/myprofile")}
        >
          <span className="qpsc-btn-gold__icon">
            <FaUserCircle />
          </span>
          My Profile
        </button>
        <button
          type="button"
          className="qpsc-btn-gold"
          onClick={() => navigate("/more")}
        >
          <span className="qpsc-btn-gold__icon">
            <FaLifeRing />
          </span>
          More / Assistance
        </button>
      </nav>

      {/* BANNER DI CHIUSURA, in coda dopo il menu. La resa è del telaio,
          `.qpsc-adbanner` (HomeShell.css): una classe sola per tutte le
          home che lo mostrano, e qui NON si crea nessun CSS proprio. NON
          è cliccabile: nessun `<a>`, nessun `onClick`, nessun `role` — è
          un'immagine e basta, e sta FUORI dal `<nav>` proprio perché non
          è una voce di navigazione. L'immagine è servita da `public/`,
          quindi non si importa: il percorso è assoluto e l'URL è
          CODIFICATO, perché il file sul disco si chiama «footer AG.png»,
          con uno spazio nel nome, e in un URL lo spazio è `%20`. */}
      <img
        className="qpsc-adbanner"
        src="/assets/footer%20AG.png"
        alt="AustraliaGoal"
      />
    </HomeShell>
  );
};

export default HomeCoach;
